export * from './shopilink.routes';
